import React from 'react';
import ColorPickerField from './ColorPickerField';

const StarProperties = ({ shape, onChange }) => {
  const handleFillColorChange = (color) => {
    onChange({ ...shape, fill: color });
  };

  const handleBorderColorChange = (color) => {
    onChange({ ...shape, stroke: color });
  };

  const handleBorderThicknessChange = (event) => {
    const newStrokeWidth = parseInt(event.target.value);
    onChange({ ...shape, strokeWidth: newStrokeWidth });
  };

  return (
    <div className="shape-specific-properties">
      <ColorPickerField
        label="Fill Color"
        color={shape.fill}
        onChange={handleFillColorChange}
      />
      <ColorPickerField
        label="Border color"
        color={shape.stroke}
        onChange={handleBorderColorChange}
      />
      <div className="shape-property">
        <label className="shape-property-label">Border thickness</label>
        <input type="number" value={shape.strokeWidth || ''} onChange={handleBorderThicknessChange} style={{width: '50px'}} />
      </div>
    </div>
  );
};

export default StarProperties;
